export default "__VITE_ASSET__COWbGlud__"